// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__9fdHY","coin":"styles_coin__yKT1-","jump":"styles_jump__C7Y2U","visuallyHidden":"styles_visuallyHidden__LcVac"};